import React from 'react';

import useModifyMutation from './useModifyMutation';


export default function withModifyMutation (WrappedComponent) {
	const ReturnedComponent = function (props) {
		const {
			data,			// From the detail query
			modifyMutation, // The GraphQL document
			id,
			optimisticResponse,
			optimisticResponseCondition,
			skipResizingImages,
			filePath,
		} = props;

		const { modifyItem, modifyItemStatus } = useModifyMutation({
			modifyMutation,
			id,
			data,
			optimisticResponse,
			optimisticResponseCondition,
			skipResizingImages,
			filePath,
		});

		return (
			<WrappedComponent
				modifyItem={modifyItem}
				modifyItemStatus={modifyItemStatus}
				errors={modifyItemStatus.validationErrors}
				{...props}
			/>
		);
	};

	return ReturnedComponent;
}

